import React from "react";
import { Link } from "react-router-dom";
import "../../style/hub.css";
import { EternalReturnIcon, MapleIcon } from "./icons";

export default function GameHub() {
  return (
    <div className="hub-page">
      <div className="hub-buttons">
        <Link to="/bser-top-ranker" className="hub-square-button hub-square-button--er">
          <EternalReturnIcon />
          <span className="hub-label">이리</span>
        </Link>
        {/* /maple은 choco-proxy가 다른 컨테이너로 라우팅하는 경로라 풀 페이지 이동 필요 */}
        <a href="/maple" className="hub-square-button hub-square-button--maple">
          <MapleIcon />
          <span className="hub-label">메이플</span>
        </a>
      </div>
    </div>
  );
}
